type CreateS3FormDataParams = {
  fields: Record<string, string>;
  file: File;
};

/**
 * Creates FormData for S3 upload with presigned URL fields
 * Based on the pattern from src/utils/fileUtil.js:uploadFile
 *
 * @param fields - The fields object from the presigned URL response (includes Content-Type)
 * @param file - The file to upload
 * @returns FormData ready for S3 upload
 */
export function createS3FormData({ fields, file }: CreateS3FormDataParams): FormData {
  const formData = new FormData();

  // Append all AWS signature fields
  Object.entries(fields).forEach(([key, value]) => {
    formData.append(key, value);
  });

  // Append the actual file last (required by S3)
  formData.append("file", file);

  return formData;
}
